import React, { createContext, useState } from 'react';

/** @type {UserProfile} */
const initialState = {
  user: {
    signedIn: false,
    greeting: '',
    basket: { items: 0 },
    shopperId: '',
  },
};

/** @type {{ userState: UserProfile, updateUserState: (nextUserState: UserProfile) => void }} */
const defaultUserContext = {
  userState: initialState,
  updateUserState: () => {},
};

export const UserContext = createContext(defaultUserContext);

export const UserContextProvider = props => {
  const [userState, updateUserState] = useState(initialState);

  return (
    <UserContext.Provider value={{ userState, updateUserState }}>
      {props.children}
    </UserContext.Provider>
  );
};
